<!--移动到弹窗 Sag 2020-4-16-->
<template>
<ya-dialog-box class="class-space-dialog" :visible.sync="dialogVisible" :width=width multi-layer :fast-close="false" :father-action="dialogBoxAction" top="18%">
  <p slot="title">{{title ? title : '提示'}}</p>
  <div class="its-container">
    <span class="its-title">保存位置：</span>
    <el-tree ref="dataTree" node-key="id" class="its-tree" :data="treeData" :expand-on-click-node="true"
         :props="props" @node-click="handleNodeClick" accordion :default-expanded-keys="defaultExpandedKeys">
         <p slot-scope="{node,data}" class="customize-tree-p">
              <span v-if="parseInt(data.id) > 0" class="its-file"></span>
              <span class="li-node-title" :class="node&&node.isCurrent ? 'active':''" :title="data.fileName">
                {{data.fileName}}
              </span>
          </p>
    </el-tree>
  </div>
  <template slot="btn">
    <button class="ts-base-btn ts-primary-btn padding" @click="dialogAction('close')" style="margin-right: 10px">取消</button>
    <button class="ts-base-btn ts-primary-btn plain padding" @click="dialogAction('ok')" :disabled="this.selectedItm==''">确定</button>
  </template>
</ya-dialog-box>
</template>
<script>
import YaDialogBox from '../../../../components/YaDialogBox'
import { classSpaceApi } from '@/utils/api'
export default {
  name: 'MoveToDialog',
  components: {
    YaDialogBox
  },
  props: {
    width: {
      type: String,
      default: '400px'
    },
    defaultCheckedKeys: {
      default: 0
    },
    defaultProps: {
      type: Object,
      default: function () {
        return {
          label: 'fileName',
          children: 'childFolder',
          isLeaf: 'isLeaf'
        }
      }
    },
    title: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    fatherAction: {
      type: Function,
      default: null
    }
  },
  data () {
    return {
      props: {
        label: 'fileName',
        children: 'childFolder',
        isLeaf: 'isLeaf'
      },
      defaultExpandedKeys: [0],
      selectedItm : '',
      selectedNode: {},
      treeData: [
        {
          id: 0,
          fileName: '全部文件',
          childFolder: [],
          filePath: '0'
        }
      ]
    }
  },
  computed: {
    subjectId: function () {
      return this.$store.state.subjectId
    }
  },
  mounted () {
    
  },
  methods: {
    dialogAction: function (type) {
      if(type === 'ok') {
        if(!this.selectedItm){
          this.$message.warning('请选择移动位置')
          return
        }
      }
      if(this.fatherAction) {
        this.fatherAction({type: type, item: this.selectedItm})
      }
    },
    dialogBoxAction: function (data) {
      if(this.fatherAction) {
        this.fatherAction(data)
      }
    },
    handleClose: function () {
      if(this.fatherAction) {
        this.fatherAction({type: 'close', item: this.selectedItm})
      }
    },
    handleNodeClick: function (data, node) {
      console.log(data, node)
      this.selectedItm = data
    },
    getTreeDatas: function () {
      let params = {
        subjectId: this.subjectId
      }
      classSpaceApi.getNewFolderList(params).then((res) => {
        console.log(res)
        if (res.success) {
          let result = res.body
          if (!result) {
            this.$message.error('抱歉！您不能将自己任教科目以外的资源分享到班级空间！')
          } else {
            this.treeData[0].childFolder = result
            this.$nextTick(() => {
              if (this.$refs.dataTree) {
                this.defaultExpandedKeys = [this.defaultCheckedKeys]
                let currentNode = this.$refs.dataTree.getNode(this.defaultCheckedKeys)
                if (currentNode) {
                  currentNode.isCurrent = true
                  // this.$refs.dataTree.setCurrentNode(currentNode)
                  this.selectedItm = currentNode.data
                }
              }
            })
          }
        } else {
          this.$message.error(res.message)
        }
      })
    }
  },
  watch: {
    dialogVisible: function () {
      if (this.dialogVisible) {
        this.getTreeDatas()
      }
    }
  }
}
</script>
<style scoped>
.its-tree{
  display: inline-block;
  width: 300px;
  overflow: auto;
}
.its-title {
  vertical-align: top;
}

.li-node-icon {
  width: 17px;
  height: 17px;
}

.its-file {
  background-image: url(../../../../assets/images/file.png);
  background-size: 100%;
  background-repeat: no-repeat;
  width: 17px;
  height: 14px;
  display: inline-block;
  vertical-align: text-top;
}

.li-node-title {
  color: #262626;
  font-size: 14px;
  margin-left: 2px;
}

.li-node-title.active {
  color: #2695FF;
}
</style>